// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Form from "@sothebys/sterling/form";

var Checkbox = {};

var _map = {"small":"small","normal":"normal"};

function inputSizeToJs(param) {
  return param;
}

function inputSizeFromJs(param) {
  return _map[param];
}

var _map$1 = {"text":"text","search":"search","password":"password","number":"number"};

function inputTypeToJs(param) {
  return param;
}

function inputTypeFromJs(param) {
  return _map$1[param];
}

var make = Form.Input;

var Input = {
  inputSizeToJs: inputSizeToJs,
  inputSizeFromJs: inputSizeFromJs,
  inputTypeToJs: inputTypeToJs,
  inputTypeFromJs: inputTypeFromJs,
  make: make
};

var Radio = {};

function MakeSelect(Config) {
  var _map = {"small":"small","normal":"normal","large":"large"};
  var formSizeToJs = function (param) {
    return param;
  };
  var formSizeFromJs = function (param) {
    return _map[param];
  };
  var Item = {};
  var _map$1 = {"left":"left","right":"right"};
  var horizontalAlignmentToJs = function (param) {
    return param;
  };
  var horizontalAlignmentFromJs = function (param) {
    return _map$1[param];
  };
  var _map$2 = {"top":"top","bottom":"bottom"};
  var verticalAlignmentToJs = function (param) {
    return param;
  };
  var verticalAlignmentFromJs = function (param) {
    return _map$2[param];
  };
  var UnsafeMenu = {};
  var SterlingForms$Select$MakeSelect$Menu = function (props) {
    return React.createElement(Form.Select.Menu, {
                menuHorizontalAlignment: Belt_Option.map(props.menuHorizontalAlignment, horizontalAlignmentToJs),
                menuVerticalAlignment: Belt_Option.map(props.menuVerticalAlignment, verticalAlignmentToJs),
                className: props.className,
                children: props.children
              });
  };
  var Menu = {
    UnsafeMenu: UnsafeMenu,
    make: SterlingForms$Select$MakeSelect$Menu
  };
  return {
          formSizeToJs: formSizeToJs,
          formSizeFromJs: formSizeFromJs,
          Item: Item,
          horizontalAlignmentToJs: horizontalAlignmentToJs,
          horizontalAlignmentFromJs: horizontalAlignmentFromJs,
          verticalAlignmentToJs: verticalAlignmentToJs,
          verticalAlignmentFromJs: verticalAlignmentFromJs,
          Menu: Menu
        };
}

var Select = {
  MakeSelect: MakeSelect
};

export {
  Checkbox ,
  Input ,
  Radio ,
  Select ,
}
/* make Not a pure module */
